const { useEffect } = require("react")

const useOverlay = (active) => {
    const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'auto' });
    useEffect(() => {
        if (active) {
            scrollToTop();
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [active]);
}

export default useOverlay;